import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.exact({
  profile: PropTypes.exact({
    email: PropTypes.string,
    fullName: PropTypes.string,
    id: PropTypes.string.isRequired,
  }).isRequired,
  archetype: PropTypes.exact({
    percentage: PropTypes.number.isRequired,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    visitDate: PropTypes.string.isRequired,
  }).isRequired,
}));
